import Defines from '../Defines';
import actions from "../actions";
const { updatePopups } = actions.popup;

/**
 * Get title from popup
 * @param {string} id
 * @param {string} lang NL || EN
 * @return {string}
 */
const getTitle = (id, lang) => {
  const popup = Defines.popups[id] || {};
  return popup[`Titel vraagteken ${lang}`] || popup['Titel vraagteken'] || '';
};

/**
 * Get device info (m or d) & difficulty (h or l)
 * @param {int} diff  1 || 2
 */
const getPopupDeviceDifficulty = (diff) => {
  const device  = document.querySelector('#root').clientWidth >= 1240 ? 'd' : 'm';
  const difficulty = diff === 1 ? 'h' : 'l';
  return device + difficulty;
};

/**
 * Get device info (m or d) & difficulty (h or l)
 * @param {int} game
 */
const getPopupCurrentGame = (game) => {
  let gameToCheck;

  if(isNaN((parseInt(game, 10)))){
    gameToCheck = game.toLowerCase();
  } else {
    gameToCheck = parseInt(game, 10);
  }

  switch(gameToCheck) {
    case 1:
    case 'ss':
      return 'landbesturen';
    case 2:
    case 'gr':
      return 'ghettoradio';
    case 3:
    case 'bo':
      return 'extraopdrachten';
    case 4:
    case 'er':
      return 'escaperoute';
    case 5:
    case 'fq':
      return 'filmquiz';
    case 6:
    case 'dt':
      return 'detectives';
    case 7:
    case 'mf':
      return 'moviefactory';
    case 8:
    case 'mc':
      return 'makeachange';
    case 9:
    case 'ht':
      return 'hennatattoos';
    case 10:
    case 'ar':
      return 'africanadventurerace';
    case 11:
    case 'tc':
      return 'truecomics';
    // case 15:
    // case 'ts':
    //   return 'urlstopsecret';
    case 16:
    case 'hl':
      return 'hotlist';
    case 17:
    case 'sa':
      return 'streetart';
    case 18:
    case 'wq':
      return 'wordquest';
    case 19:
    case 'vm':
      return 'votematch';
    case 20:
    case 'ga':
      return 'guessagain';
    case 23:
    case 'wa':
      return 'wanted';
    case 24:
    case 'tr':
      return 'totalrecall';
    case 25:
    case 'fc':
      return 'factcheck';
    case 26:
    case 'rm':
      return 'readtheminds';
    case 27:
    case 'fq2':
      return 'filmquiz2';
    default:
      return false;
  }
};

/**
 * Get content from popup
 * @param {string} id
 * @param {string} lang  NL || EN
 * @return {string}
 */
const getContent = (id, lang) => {
  console.log("ID:", id);
  const popup = Defines.popups[id] || {};
  return (popup[`Tekst ${lang}`] || popup['Tekst'] || '').replace(/http(s)?:\/\//g, '//');
};

/**
 * Get next popup
 * @param {string} id
 * @return {string} next popup id
 */
const getNext = (id, tutorial = true) => {
  const popup = Defines.popups[id] || {};
  if(tutorial) {
    return popup['Tutorial volgende'];
  } else {
    return popup['Volgende'];
  }
};

/**
 * Get if popup is auto (show once or more)
 * @param {string} id
 * @return {boolean} is auto or not
 */
const getAuto = id => {
  const popup = Defines.popups[id] || {};
  return (popup['Auto?'] !== "" && popup['Auto?'] !== undefined ? true : false);
};

/**
 * Get if popup is read
 * @param {string} id
 * @return {boolean} is read or not
 */
const getLocalRead = id => {
  let localReadJSON = sessionStorage.getItem('localRead') || '{}';
  const localRead = JSON.parse(localReadJSON);
  return (id in localRead && localRead[id] ? true : false);
};

/**
 * Get if popup is read
 * @param {string} id
 * @return {boolean} is read or not
 */
const dispatchUnreadPopup = (id, dispatch, closeable = false, desktop = false) => {
  const isDesktop = document.querySelector('#root').clientWidth >= 1240;
  const popupId = !isDesktop ? id : 'd' + id.substring(1);
  if (sessionStorage.getItem('governAsClassleader') === 'true' && getAuto(id)) {
    return false;
  }
  if(!getLocalRead(popupId)){
    dispatch(updatePopups({popupId: popupId, isDesktop: desktop, closeable: closeable, tutorial: true}));
    return true;
  } else {
    return false;
  }
};

/**
 * Get location route of popup
 * @param {string} id
 * @return {string} location pathname -or- null if invalid
 */
const getRoute = (id, desktop = false) => {
  let popup = Defines.popups[id] || {};
  popup = popup['Locatie'];
  if(!popup || popup === undefined) {
    //PopupID bestaat niet.
    return "/";
  }
  const rawLocation = popup.replace(/\s/g, '').toLowerCase();
  const locations = (desktop ? Defines.popupLocationsDesktop : Defines.popupLocations)
  if( rawLocation in locations) {
    return locations[rawLocation];
  }
  return null;
};

/**
 * Set localpopup read
 * @param {string} id
 * @return {boolean} success true false
 */
const setLocalRead = id => {
  let localReadJSON = sessionStorage.getItem('localRead') || '{}';
  const localRead = JSON.parse(localReadJSON);
  localRead[id] = true;
  localReadJSON = JSON.stringify(localRead);
  sessionStorage.setItem('localRead', localReadJSON);
};

/**
 * Get next popup
 * @param {string} id
 * @return {int} count of tutorial popups
 */
const getAllTourPopups = (id, tutorial = true) => {
  let total = 1;
  const allPopups = Defines.popups || {};
  const checkNext = item => {
    if (item) {
      let next = (tutorial ? item['Tutorial volgende'] : item['Volgende']);
      if (next) {
        total++;
        return checkNext(allPopups[next]);
      } else {
        if (total > 1) {
          return total;
        }
        return 1;
      }
    } else {
      if (total > 1) {
        return total;
      }
      return null;
    }
  };

  return checkNext(allPopups[id]);

};

export {
  getTitle,
  getPopupDeviceDifficulty,
  getPopupCurrentGame,
  getContent,
  getNext,
  getAuto,
  getRoute,
  setLocalRead,
  getLocalRead,
  dispatchUnreadPopup,
  getAllTourPopups
};



// WEBPACK FOOTER //
// ./src/helpers/popupHelper.js